import {
  ProductAssetsDrawerV2CarouselImportedTabPanel,
  ProductAssetsDrawerV2CarouselSparkTabPanel,
  ProductAssetsDrawerV2CarouselTabPanel,
  ProductAssetsDrawerV2 as ProductAssetsDrawerV2Component,
  ProductAssetsDrawerV2Content,
  type ProductAssetsDrawerV2ContentProps,
  ProductAssetsDrawerV2HeroImportedTabPanel,
  ProductAssetsDrawerV2HeroSparkTabPanel,
  ProductAssetsDrawerV2HeroTabPanel,
  type ProductAssetsDrawerV2Props,
  ProductAssetsDrawerV2Trigger,
} from './product-assets-drawer-v2';

/**
 * V2 product assets drawer component. Kept alongside V1 (`ProductAssetsDrawer`)
 * so rollback via the `pdp-v-2` LaunchDarkly flag is a single switch.
 *
 * @param props - The props for the product assets drawer.
 * @returns The V2 product assets drawer component.
 *
 * @example
 *   <ProductAssetsDrawerV2 {...args}>
 *     <div className="flex flex-col gap-4 p-8 h-screen">
 *       <div>
 *         <ProductAssetsDrawerV2.Trigger>
 *           <Button level={ButtonLevel.Secondary} iconStart={<Image01Icon />}>
 *             Product Assets
 *           </Button>
 *         </ProductAssetsDrawerV2.Trigger>
 *       </div>
 *     </div>
 *     <ProductAssetsDrawerV2.Content>
 *       <ProductAssetsDrawerV2.HeroTabPanel>Hero Tab Panel</ProductAssetsDrawerV2.HeroTabPanel>
 *       <ProductAssetsDrawerV2.CarouselTabPanel>Carousel Tab Panel</ProductAssetsDrawerV2.CarouselTabPanel>
 *     </ProductAssetsDrawerV2.Content>
 *   </ProductAssetsDrawerV2>
 */
const ProductAssetsDrawerV2 = Object.assign(ProductAssetsDrawerV2Component, {
  Content: ProductAssetsDrawerV2Content,
  HeroTabPanel: ProductAssetsDrawerV2HeroTabPanel,
  CarouselTabPanel: ProductAssetsDrawerV2CarouselTabPanel,
  Trigger: ProductAssetsDrawerV2Trigger,
});

export {
  ProductAssetsDrawerV2,
  ProductAssetsDrawerV2CarouselImportedTabPanel,
  ProductAssetsDrawerV2CarouselSparkTabPanel,
  ProductAssetsDrawerV2HeroImportedTabPanel,
  ProductAssetsDrawerV2HeroSparkTabPanel,
};
export type { ProductAssetsDrawerV2Props, ProductAssetsDrawerV2ContentProps };
